/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateVendorSymptomDto } from '../../models/update-vendor-symptom-dto';
import { VendorSymptomDto } from '../../models/vendor-symptom-dto';

export interface AsControllerUpdateVendorSymptom$Params {
  clientWorkspaceId: string;
  symptomId: string;
      body: UpdateVendorSymptomDto
}

export function asControllerUpdateVendorSymptom(http: HttpClient, rootUrl: string, params: AsControllerUpdateVendorSymptom$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorSymptomDto>> {
  const rb = new RequestBuilder(rootUrl, asControllerUpdateVendorSymptom.PATH, 'patch');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.path('symptomId', params.symptomId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorSymptomDto>;
    })
  );
}

asControllerUpdateVendorSymptom.PATH = '/api/v1/as/vendor/{clientWorkspaceId}/symptoms/{symptomId}';
